import React, { useState, Fragment } from 'react'
import Slider from '@material-ui/core/Slider';
import { styled } from '@material-ui/core/styles';
import _ from 'lodash';

type FieldValues = {
  name: string, 
  label: string,
  error: any, 
  inputRef: any, 
  defaultValue: number,
  defaultSliderPosition?: number, 
  min: number, 
  step: number, 
  max: number,
  marks: Array<Mark>,
  defaultMark: Mark,
  marksDescriptions: Array<Mark>, 
  onChange: any
};

interface Mark {
  value: number, 
  label: string
}

const iOSBoxShadow = '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)';
const CustomSlider = styled(Slider)(({ theme }) => ({
  padding: '45px 0',
  margin: 0, 
  color: '#ccc',
  '& .MuiSlider-rail': {
    color: '#ccc',
    opacity: 1
  },
  '& .MuiSlider-track': {
    color: '#EB0A1E'
  },
  '& .MuiSlider-thumb': {
    height: 34,
    width: 34,
    marginTop: -17,
    marginLeft: -17, 
    backgroundColor: '#fff',
    boxShadow: iOSBoxShadow,
    '&:focus, &:hover, &.Mui-active': {
      boxShadow:
        '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.3),0 0 0 1px rgba(0,0,0,0.02)',
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        boxShadow: iOSBoxShadow,
      },
    },
  },
  '& input + .MuiSlider-mark + .MuiSlider-markLabel:not(:nth-last-child(2))': {
      transform: 'none'
  },
  '& input + .MuiSlider-mark ~ .MuiSlider-mark + .MuiSlider-markLabel:nth-last-child(2)': {
      transform: 'translateX(-100%)'
  },
  // '& input + .MuiSlider-mark + .MuiSlider-markLabelActive': {
  //   color: '#1a1a1a'
  // },
  '& .MuiSlider-markLabel': {
    top: 70, 
    fontSize: 12,
    fontFamily: 'ToyotaType, sans-serif',
    color: '#707070',
  }, 
  '& .MuiSlider-mark': {
    backgroundColor: 'inherit'
  }
}));

const FieldSlider: React.FC<FieldValues> = ({ name, label, error, inputRef, defaultValue, defaultSliderPosition, min, step, max, marks, defaultMark, marksDescriptions, onChange }) => {
  const [fieldValue, setFieldValue] = useState(defaultValue);
  const [isTouched, setIsTouched] = useState(false);
  const handleChange = (e: any, v: any) => {
    const v2 = step * Math.round(v/step);
    setIsTouched(true);
    setFieldValue(v2);
    onChange(v2);
  }
  return (
    <Fragment>
      <div className={`i-form-group i-slider ${!defaultSliderPosition || isTouched ? '' : 'i-untouched'}`}>
        <label htmlFor={name}>
          {label}
        </label>
        <CustomSlider ref={inputRef} 
          className={`i-slider-control i-val-${fieldValue}`}
          marks={defaultSliderPosition && fieldValue == defaultValue ? [defaultMark] : marks}
          min={min}
          max={max}
          step={1}
          defaultValue={defaultSliderPosition || defaultMark.value}
          onChange={handleChange}
        />
        {error ? <div className="i-form-group-text i-has-error">This is required</div> : 
          <div className={`i-form-group-text`}>{marksDescriptions.filter(o => o.value == fieldValue).map(o => o.label)} &nbsp;</div>
        }
      </div>
    </Fragment>
  )
}

export default FieldSlider
